import CourseCard from "../../../components/CourseCard";
import { blogImageSrc, COURSE_PLACEHOLDER } from "../../../api/blogImage";

function PopularCoursesSection({ data }) {
  const courses = Array.isArray(data) ? data : [];

  return (
    <div className="section-space">
      <div className="container">
        <div className="text-center mb-5">
          <h2>
            Popular <span className="text-gradient">Courses</span>
          </h2>
          <p>Categories learners are choosing right now.</p>
        </div>

        {courses.length === 0 ? (
          <p className="text-center">No popular courses available right now.</p>
        ) : (
          <div className="row g-4">
            {courses.map((course) => (
              <div className="col-md-6 col-lg-4" key={course._id || course.slug || course.title}>
                <CourseCard
                  title={course.title}
                  thumbnail={blogImageSrc(course.thumbnail || course.icon, COURSE_PLACEHOLDER)}
                  instructor={course.courses}
                  to={course.link || "/courses"}
                  actionLabel="View Courses"
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default PopularCoursesSection;
